<ul class="tabset__list">
    <li
        class="tabset__option"
        *ngFor="let tab of tabs"
        (click)="selectTab(tab)"
        [class.active]="tab.active"
        [id]="tab.id"
        [ngClass]="{ hidden: tab.hidden }"
    >
        <svg *ngIf="tab.icon" class="tabset__icon svg-icon svg-icon--l">
            <use [attr.href]="'assets/icons-general.svg#' + tab.icon"></use>
        </svg>
        <a href="#">{{ tab.tabTitle }}</a>
    </li>
</ul>
<ng-content></ng-content>
